import styled from 'styled-components';

export const Card = styled.div`
  background: #FFF;
  width: 30%;
  height: 6rem;
  padding: 0.8rem 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;

  .progress-bar {
    width: 4.5rem;
    height: 4.5rem;
    border-radius: 50%;
    background-color: #000;
    border: 4px solid rgb(120,129,152);
    position: relative;
    img {
      position: absolute;
      left: 28%;
      top: 32%;
    }
  }
  .card-text {
    margin-left: 1rem;
    strong {
      color: var(--light-blue);
      font-size: 1.2rem;
    }
    p {
      font-size: 1rem;
    }
  }

  @media (max-width: 980px) {
    width: 100%;
  }
`;
